import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

import { TextField, TextFieldProps } from '@mui/material';

interface RHFTextFieldProps {
  name: string;
}

export const RHFTextFieldPhone = ({ name, ...other }: RHFTextFieldProps & TextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => (
        <InputMask mask="+380999999999" value={field.value} onChange={field.onChange} type="tel">
          {(inputProps: TextFieldProps) => (
            <TextField
              error={!!error}
              fullWidth
              type="tel"
              helperText={error?.message}
              placeholder="+380 __ ___ __ __"
              {...inputProps}
              {...other}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.800'),
                },
              }}
            />
          )}
        </InputMask>
      )}
    />
  );
};
